import { FORM_STATES } from '@bingads-webui-fluent-component/form';
import { PMAX_LITE_WIZARD_STEP_PATHS } from '@bingads-webui-campaign-react/pmax-lite-wizard-utils';
import { DelayedAllCampaignTypeSelectionStepWithI18n } from './delayed-all-campaign-type-selection-step';

export const AllCampaignTypeSelectionStepConfig = {
  id: PMAX_LITE_WIZARD_STEP_PATHS.ALL_CAMPAIGN_TYPE_SELECTION,
  view: DelayedAllCampaignTypeSelectionStepWithI18n,
  machineOptions: {
    initialState: FORM_STATES.FETCHING,
    guards: {
      needsLoading: () => false,
      needsSaving: () => false,
    },
  },
};
